export const WL_ID_19 = 19;
export const WL_ID_19_COMPONENTS_VERSION = 'eto';
